var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{attrs:{"id":"footer"}},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('p',[_vm._v(" © Copyright 2020 "),_c('a',{attrs:{"href":"#"}},[_vm._v("Kobe")]),_vm._v(". All Rights Reserved ")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }